import { uniqueId, onEvent } from "./_dom";
import { closePopup } from "./_menu";
import { registerComponent } from "./component";

class DateRangePickers {
	constructor(daterange) {
		this.daterange = daterange;
		this.btn = this.daterange.querySelector('.v3-daterange__drop');
		this.btn.id = uniqueId("daterange");
		this.popup = this.daterange.querySelector('.v3-daterange__popup');
		this.popup.id = uniqueId("daterange");
		this.btn.setAttribute("aria-haspopup", "true");
		this.btn.classList.add("v3-select", "js-auto-popup");
		this.btn.setAttribute("aria-controls", this.popup.id);
		this.datepicker = this.daterange.querySelector(".v3-daterange__pickers");
		this.id = this.daterange.dataset.id;
		this.open = false;
	}
	selectItem(target) {
		const link = target;
		const item = link.closest('li');
		const text = link.textContent;
		const from = item.dataset.from;
		const to = item.dataset.to;
		const custom = item.dataset.custom === "true";
		this.daterange.querySelector(`input[name="${this.id}_from"]`).value = from;
		this.daterange.querySelector(`input[name="${this.id}_to"]`).value = to;
		this.datepicker.style.display = custom ? "" : "none";
		this.btn.querySelector('span').replaceChildren(text);
	}
	init() {
		onEvent(this.popup, ".v3-menu__item", "click", (event, target) => {
			event.preventDefault();
			this.selectItem(target);
			closePopup(this.popup);
		});
		return this;
	}
}

function createDateRange(daterange) {
	const newDaterange = new DateRangePickers(daterange).init();
	return newDaterange;
}

const daterange = registerComponent(createDateRange);

function init(context, selector = ".v3-daterange") {
	return daterange(selector, context);
}

export { init };